
<div class="container-fluid spacing">
    <div class="pos-f-t">
        <nav class="navbar navbar-dark bg">
            <h1>Snow</h1>
          <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarToggleExternalContent" aria-controls="navbarToggleExternalContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
        </nav>
        <div class="collapse" id="navbarToggleExternalContent">
            <div class="bg2 p-4 text-center">
              <div class="navbar-nav">
                <a class="nav-link active" href="#">Home <span class="sr-only">(current)</span></a>
                <a class="nav-link" href="#">Features</a>
                <a class="nav-link" href="#">Pricing</a>
                <a class="nav-link disabled" href="#" tabindex="-1" aria-disabled="true">Disabled</a>
              </div>
            </div>
          </div>
      </div>
      <div class="row justify-content-center">
          <div class="col-sm-8 ">
            <div class="card bg2 text-center">
                <div class="card-body h4">
                    <h4 class="card-text one">Lorem ipsum dolor </h4>
                    <p class="card-title h1">Lorem ipsum dolor sit amet consectetur.</p>
                     <p class="card-subtitle h2">Your publish on web</p>   
                </div>
            </div>
          </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-xs-12">
            <div class="card bg2">
              <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarToggleExternalContent" aria-controls="navbarToggleExternalContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon">
                  <img src="../../../assets/img/icon/arrow.png" alt="">
                </span>
              </button>
              
            </div>
          </div>
      </div>
</div>
